import { useTranslation } from 'react-i18next'

/** `Suspense` fallback for lazy-loaded route chunks — the gap is a network
 * fetch of already-cached JS, typically imperceptible, so this stays minimal
 * rather than a full skeleton. */
export function RouteFallback() {
  const { t } = useTranslation('common')
  return <p className="text-sm text-muted-foreground">{t('state.loading')}</p>
}
